module.exports = __webpack_public_path__ + "static/56b301458b7c72e1d6d2a1b54517dd7d0f7ca4b3484f487be91182bc75c80bec-4d0285dd8597e920b4f4f6de3e3ebf81.png";